
		<div class="not-found-container">
			<img src="assets/img/404.png" alt="404" class="error-image" />
		</div>
	